"use strict";

/**
 * Root-only user & group management (replaces NMS_Prev/userConfiguration.php).
 */
module.exports = function initUserManagement(opts) {
  var $ = opts.$;
  var isRootUser = opts.isRootUser;
  var $tab = opts.$tab;
  var roles = [];
  var treeNodes = [];
  var groupsCache = [];
  var initialized = false;

  function post(method, data, done) {
    var payload = $.extend({ method: method }, data || {});
    $.post("adminservice.php", payload, done, "json");
  }

  function showMsg($el, text, isError) {
    $el.text(text || "");
    $el.toggleClass("text-danger", !!isError);
    $el.toggleClass("text-info", !isError);
  }

  function loadRoles(cb) {
    post("userMgmtListRoles", {}, function (res) {
      if (res.isOkay) {
        roles = res.roles || [];
        renderRoleCheckboxes();
      }
      if (cb) cb();
    });
  }

  function loadTreeNodes(cb) {
    post("userMgmtListTreeNodes", {}, function (res) {
      if (res.isOkay) {
        treeNodes = res.nodes || [];
        fillTreeSelect($("#UserMgmtGroupViewTree"));
        fillTreeSelect($("#UserMgmtGroupEditTree"));
      }
      if (cb) cb();
    });
  }

  function fillTreeSelect($select) {
    $select.empty();
    $select.append($("<option>", { value: "", text: "(none)" }));
    treeNodes.forEach(function (n) {
      $select.append(new Option(n.parent + " / " + n.node_name, n.id));
    });
  }

  function renderRoleCheckboxes() {
    var $box = $("#UserMgmtGroupRoles");
    $box.empty();
    roles.forEach(function (role, idx) {
      var id = "UserMgmtRole_" + idx;
      $box.append(
        $("<div>").append(
          $("<label>").append(
            $("<input>", { type: "checkbox", value: role, id: id }),
            document.createTextNode(" " + role)
          )
        )
      );
    });
  }

  function getSelectedRoles() {
    var selected = [];
    $("#UserMgmtGroupRoles input:checked").each(function () {
      selected.push($(this).val());
    });
    return selected;
  }

  function setSelectedRoles(roleCsv) {
    var set = {};
    (roleCsv || "").split(",").forEach(function (r) {
      if (r) set[$.trim(r)] = true;
    });
    $("#UserMgmtGroupRoles input").each(function () {
      $(this).prop("checked", !!set[$(this).val()]);
    });
  }

  function loadGroups() {
    post("userMgmtListGroups", {}, function (res) {
      if (!res.isOkay) return;
      groupsCache = res.groups || [];
      var $tbody = $("#UserMgmtGroupsTable tbody");
      $tbody.empty();
      groupsCache.forEach(function (g) {
        var $tr = $("<tr>");
        $tr.append($("<td>").text(g.name));
        $tr.append($("<td>").text(g.description || ""));
        $tr.append($("<td>").text(g.viewtree || ""));
        $tr.append(
          $("<td>").append(
            $("<button>", { type: "button", class: "btn btn-xs btn-default" })
              .text("Edit")
              .data("group", g)
              .on("click", function () {
                fillGroupForm($(this).data("group"));
              }),
            " ",
            g.name !== "root"
              ? $("<button>", {
                  type: "button",
                  class: "btn btn-xs btn-danger",
                })
                  .text("Delete")
                  .on("click", function () {
                    if (
                      confirm(
                        "Delete group " + g.name + " and all its users?"
                      )
                    ) {
                      post("userMgmtDeleteGroup", { id: g.id }, function (r) {
                        if (r.isOkay) {
                          loadGroups();
                          loadUsers();
                          resetGroupForm();
                        } else {
                          alert(r.error || "Delete failed");
                        }
                      });
                    }
                  })
              : null
          )
        );
        $tbody.append($tr);
      });
      fillGroupSelect();
    });
  }

  function fillGroupSelect() {
    var $sel = $("#UserMgmtUserGroup");
    var cur = $sel.val();
    $sel.empty();
    groupsCache.forEach(function (g) {
      $sel.append($("<option>", { value: g.id, text: g.name }));
    });
    if (cur) $sel.val(cur);
  }

  function loadUsers() {
    post("userMgmtListUsers", {}, function (res) {
      if (!res.isOkay) return;
      var $tbody = $("#UserMgmtUsersTable tbody");
      $tbody.empty();
      (res.users || []).forEach(function (u) {
        var flags = [];
        if (u.is_disabled == 1) flags.push("disabled");
        if (u.is_temp_date == 1) flags.push("temp");
        if (u.is_password_ageing == 1) flags.push("ageing");
        if (u.is_strict_password == 1) flags.push("strict");
        var $tr = $("<tr>");
        $tr.append($("<td>").text(u.name));
        $tr.append($("<td>").text(u.groupName || ""));
        $tr.append($("<td>").text(flags.join(", ")));
        $tr.append(
          $("<td>").append(
            $("<button>", { type: "button", class: "btn btn-xs btn-default" })
              .text("Edit")
              .on("click", function () {
                post("userMgmtGetUser", { id: u.id }, function (r) {
                  if (r.isOkay && r.user) fillUserForm(r.user);
                });
              }),
            " ",
            u.name !== "root"
              ? $("<button>", {
                  type: "button",
                  class: "btn btn-xs btn-danger",
                })
                  .text("Delete")
                  .on("click", function () {
                    if (confirm("Delete user " + u.name + "?")) {
                      post("userMgmtDeleteUser", { id: u.id }, function (r) {
                        if (r.isOkay) {
                          loadUsers();
                          resetUserForm();
                        } else {
                          alert(r.error || "Delete failed");
                        }
                      });
                    }
                  })
              : null
          )
        );
        $tbody.append($tr);
      });
    });
  }

  function resetGroupForm() {
    $("#UserMgmtGroupId").val("");
    $("#UserMgmtGroupName").val("");
    $("#UserMgmtGroupDesc").val("");
    $("#UserMgmtGroupViewTree").val("");
    $("#UserMgmtGroupEditTree").val("");
    $("#UserMgmtGroupCactiUser").val("0");
    $("#UserMgmtGroupLuciUser").val("");
    $("#UserMgmtGroupLuciPass").val("").attr("placeholder", "");
    $("#UserMgmtGroupUseOtp").prop("checked", false);
    $("#UserMgmtGroupOtpMethod").val("0");
    $("#UserMgmtGroupOtpDomain").val("");
    setSelectedRoles("");
    showMsg($("#UserMgmtGroupMsg"), "");
    showMsg($("#UserMgmtGroupNameErr"), "");
  }

  function fillGroupForm(g) {
    $("#UserMgmtGroupId").val(g.id);
    $("#UserMgmtGroupName").val(g.name);
    $("#UserMgmtGroupDesc").val(g.description || "");
    $("#UserMgmtGroupViewTree").val(g.viewtree || "");
    $("#UserMgmtGroupEditTree").val(g.edittree || "");
    $("#UserMgmtGroupCactiUser").val(g.cactiuser || 0);
    $("#UserMgmtGroupLuciUser").val(g.luci_user_name || "");
    $("#UserMgmtGroupLuciPass")
      .val("")
      .attr("placeholder", g.has_luci_password == 1 ? "(unchanged)" : "");
    $("#UserMgmtGroupUseOtp").prop("checked", g.is_use_otp == 1);
    $("#UserMgmtGroupOtpMethod").val(String(g.otp_method || 0));
    $("#UserMgmtGroupOtpDomain").val(g.otp_mail_domain || "");
    setSelectedRoles(g.role || "");
    showMsg($("#UserMgmtGroupMsg"), "Editing group " + g.name);
  }

  function resetUserForm() {
    $("#UserMgmtUserId").val("");
    $("#UserMgmtUserName").val("");
    $("#UserMgmtUserPassword").val("");
    $("#UserMgmtUserGroup").val(groupsCache.length ? groupsCache[0].id : "");
    $("#UserMgmtUserStrictPass").prop("checked", false);
    $("#UserMgmtUserTempPass").prop("checked", false);
    $("#UserMgmtUserPassAgeing").prop("checked", false);
    $("#UserMgmtUserDisabled").prop("checked", false);
    $("#UserMgmtUserUseOtp").prop("checked", false);
    $("#UserMgmtUserOtpInherit").prop("checked", true);
    $("#UserMgmtUserOtpMethod").val("0");
    $("#UserMgmtUserOtpMail").val("");
    $("#UserMgmtUserOtpPhone").val("");
    showMsg($("#UserMgmtUserMsg"), "");
    showMsg($("#UserMgmtUserNameErr"), "");
  }

  function fillUserForm(u) {
    $("#UserMgmtUserId").val(u.id);
    $("#UserMgmtUserName").val(u.name);
    $("#UserMgmtUserGroup").val(u.gid);
    $("#UserMgmtUserPassword").val("");
    $("#UserMgmtUserStrictPass").prop("checked", u.is_strict_password == 1);
    $("#UserMgmtUserTempPass").prop("checked", u.is_temp_date == 1);
    $("#UserMgmtUserPassAgeing").prop("checked", u.is_password_ageing == 1);
    $("#UserMgmtUserDisabled").prop("checked", u.is_disabled == 1);
    $("#UserMgmtUserUseOtp").prop("checked", u.is_use_otp == 1);
    $("#UserMgmtUserOtpInherit").prop("checked", u.is_otp_group_inherit == 1);
    $("#UserMgmtUserOtpMethod").val(String(u.otp_method || 0));
    $("#UserMgmtUserOtpMail").val(u.otp_mail_address || "");
    $("#UserMgmtUserOtpPhone").val(u.otp_phone_number || "");
    showMsg($("#UserMgmtUserMsg"), "Editing user " + u.name);
  }

  function validateName(field, method, excludeId, $err) {
    return new Promise(function (resolve) {
      if (!field) {
        $err.text("Name is required");
        resolve(false);
        return;
      }
      post(
        method,
        { name: field, excludeId: excludeId || 0 },
        function (res) {
          if (res.isTaken) {
            $err.text("Name already exists");
            resolve(false);
          } else {
            $err.text("");
            resolve(true);
          }
        }
      );
    });
  }

  function bindEvents() {
    $("#UserMgmtGroupReset").on("click", resetGroupForm);
    $("#UserMgmtUserReset").on("click", resetUserForm);

    $("#UserMgmtGroupSave").on("click", function () {
      var id = $("#UserMgmtGroupId").val();
      var name = $.trim($("#UserMgmtGroupName").val());
      validateName(
        name,
        "userMgmtCheckGroupName",
        id,
        $("#UserMgmtGroupNameErr")
      ).then(function (ok) {
        if (!ok) return;
        var data = {
          id: id ? parseInt(id, 10) : 0,
          name: name,
          description: $("#UserMgmtGroupDesc").val(),
          role: getSelectedRoles(),
          viewtree: $("#UserMgmtGroupViewTree").val(),
          edittree: $("#UserMgmtGroupEditTree").val(),
          cactiuser: parseInt($("#UserMgmtGroupCactiUser").val(), 10) || 0,
          luci_user_name: $("#UserMgmtGroupLuciUser").val(),
          luci_password: $("#UserMgmtGroupLuciPass").val(),
          is_use_otp: $("#UserMgmtGroupUseOtp").is(":checked") ? 1 : 0,
          otp_method: parseInt($("#UserMgmtGroupOtpMethod").val(), 10) || 0,
          otp_mail_domain: $("#UserMgmtGroupOtpDomain").val(),
        };
        post("userMgmtSaveGroup", { data: JSON.stringify(data) }, function (r) {
          if (r.isOkay) {
            showMsg($("#UserMgmtGroupMsg"), "Group saved");
            loadGroups();
            resetGroupForm();
          } else {
            showMsg($("#UserMgmtGroupMsg"), r.error || "Save failed", true);
          }
        });
      });
    });

    $("#UserMgmtUserSave").on("click", function () {
      var id = $("#UserMgmtUserId").val();
      var name = $.trim($("#UserMgmtUserName").val());
      validateName(
        name,
        "userMgmtCheckUserName",
        id,
        $("#UserMgmtUserNameErr")
      ).then(function (ok) {
        if (!ok) return;
        var data = {
          id: id ? parseInt(id, 10) : 0,
          name: name,
          gid: parseInt($("#UserMgmtUserGroup").val(), 10),
          password: $("#UserMgmtUserPassword").val(),
          is_strict_password: $("#UserMgmtUserStrictPass").is(":checked") ? 1 : 0,
          is_temp_date: $("#UserMgmtUserTempPass").is(":checked") ? 1 : 0,
          is_password_ageing: $("#UserMgmtUserPassAgeing").is(":checked") ? 1 : 0,
          is_disabled: $("#UserMgmtUserDisabled").is(":checked") ? 1 : 0,
          is_use_otp: $("#UserMgmtUserUseOtp").is(":checked") ? 1 : 0,
          is_otp_group_inherit: $("#UserMgmtUserOtpInherit").is(":checked") ? 1 : 0,
          otp_method: parseInt($("#UserMgmtUserOtpMethod").val(), 10) || 0,
          otp_mail_address: $("#UserMgmtUserOtpMail").val(),
          otp_phone_number: $("#UserMgmtUserOtpPhone").val(),
        };
        post("userMgmtSaveUser", { data: JSON.stringify(data) }, function (r) {
          if (r.isOkay) {
            showMsg($("#UserMgmtUserMsg"), "User saved");
            loadUsers();
            resetUserForm();
          } else {
            showMsg($("#UserMgmtUserMsg"), r.error || "Save failed", true);
          }
        });
      });
    });
  }

  function ensureInitialized() {
    if (initialized || !isRootUser()) return;
    initialized = true;
    bindEvents();
    loadRoles(function () {
      loadTreeNodes(function () {
        loadGroups();
        loadUsers();
        resetGroupForm();
        resetUserForm();
      });
    });
  }

  $tab.on("click", function () {
    ensureInitialized();
  });
};
